import { BO, BusinessObjectBase, Weaver } from '@skylab-shared/core';
import { AccountancyModel } from '@skylab-shared/dataModel';
import { dateDiffInDays } from '@skylab-shared/utils';
import { InvalidExchangeDateError } from './violations/invalid-exchange-date-error';


@BO({ modelType: AccountancyModel })
export class AccountancyBO extends BusinessObjectBase<AccountancyModel> {
    public constructor(
        weaver: Weaver
    ) {
        super(weaver);
    }

    protected override async initializeAsync(): Promise<void> {
        await super.initializeAsync();

        this.registerValidationRules();
    }

    private registerValidationRules(): void {
        this.registerDataExchangeDateRules();
    }

    private registerDataExchangeDateRules(): void {
        this.validation.addRule(
            [[AccountancyModel, 'period_From'], [AccountancyModel, 'period_To']],
            [[AccountancyModel, 'period_To']],
            ctx => dateDiffInDays(ctx.source.period_To, ctx.source.period_From) >= 0,
            InvalidExchangeDateError
        );
    }
}
